import PropTypes from 'prop-types';

import SimplePageTemplate from '@spotahome/landings-common/src/components/SimplePageTemplate';

import InstitutionsCities from './InstitutionsCities';

function indexInstitutionsByCity(institutions) {
  const cities = {};

  Object.keys(institutions).forEach(institutionId => {
    const { city } = institutions[institutionId];

    if (!cities[city]) {
      cities[city] = [];
    }

    cities[city].push(institutions[institutionId]);
  });

  return cities;
}

const EMPTY_OBJECT = {};

const InstitutionsList = ({ institutions = EMPTY_OBJECT }) => {
  const institutionsByCity = indexInstitutionsByCity(institutions);

  return (
    <SimplePageTemplate title="Institutions">
      <InstitutionsCities institutionsByCity={institutionsByCity} />
    </SimplePageTemplate>
  );
};

InstitutionsList.propTypes = {
  institutions: PropTypes.object.isRequired
};

export default InstitutionsList;
